module.exports = __webpack_public_path__ + "static/media/portfolio (1).52a14f35.jpg";